import { Injectable } from '@angular/core';

import { DictionaryItem } from '@hglobal/common';
import { delay, Observable, of } from 'rxjs';

import { Country, Currencies, Skin, WalletsSkinCollection } from '@pp/core/entities';

import { DictionariesApiService } from '../api';
import { getCardSkinsMock, getCountriesMock, getCurrenciesMock, getRolesMock, getWalletSkinsCollectionMock } from './dictionaries.mock';

@Injectable()
export class DictionariesMockApi extends DictionariesApiService {
  override getRoles(): Observable<DictionaryItem<string>[]> {
    const roles = getRolesMock();

    return of(roles).pipe(delay(500));
  }

  override getCurrencies(): Observable<Currencies> {
    const currencies = getCurrenciesMock();

    return of(currencies).pipe(delay(500));
  }

  override getCardsSkins(): Observable<Skin[]> {
    const skins = getCardSkinsMock(3);

    return of(skins).pipe(delay(500));
  }

  override getWalletSkins(): Observable<WalletsSkinCollection> {
    const skins = getWalletSkinsCollectionMock();

    return of(skins).pipe(delay(500));
  }

  override getCountries(): Observable<Country[]> {
    const countries = getCountriesMock();

    return of(countries).pipe(delay(500));
  }
}
